// ! 장르만 서버에서 정의한 ENUM 타입이고 나머지 타입들은 하드코딩으로 진행한 상황입니다.

export enum Genre {
  Thriller = 'Thriller',
  Horror = 'Horror',
  Fantasy = 'Fantasy',
  Comic = 'Comic',
  History = 'History',
  Detective = 'Detective',
  Drama = 'Drama',
  Emotional = 'Emotional',
  SF = 'SF',
  Educational = 'Educational'
}

export enum TemporalBackground {
  Prehistoric = 'Prehistoric',
  Medieval = 'Medieval',
  Modern = 'Modern',
  Future = 'Future',
  EarlyModern = 'EarlyModern'
}

export enum SpatialBackground {
  City = 'City',
  Countryside = 'Countryside',
  Village = 'Village',
  School = 'School',
  Laboratory = 'Laboratory',
  Hospital = 'Hospital',
  Museum = 'Museum',
  Castle = 'Castle',
  Ruins = 'Ruins',
  Desert = 'Desert',
  Jungle = 'Jungle',
  Forest = 'Forest',
  Glacier = 'Glacier',
  Ocean = 'Ocean',
  Island = 'Island',
  Cave = 'Cave',
  Underground = 'Underground',
  Labyrinth = 'Labyrinth',
  OtherPlanet = 'OtherPlanet',
  VirtualSpace = 'VirtualSpace'
}

export enum Atmosphere {
  Joyful = 'Joyful',
  Tense = 'Tense',
  Mysterious = 'Mysterious',
  Scary = 'Scary',
  Peaceful = 'Peaceful',
  Mystical = 'Mystical',
  Warm = 'Warm',
  Calm = 'Calm',
  Composed = 'Composed',
  Bright = 'Bright',
  Hopeful = 'Hopeful',
  Dreamy = 'Dreamy',
  Cheerful = 'Cheerful',
  Dark = 'Dark',
  Cold = 'Cold'
}

export enum StoryGoal {
  Rescue = 'Rescue',
  FindItem = 'FindItem',
  RevealSecret = 'RevealSecret',
  DiscoverPlace = 'DiscoverPlace',
  Investigate = 'Investigate',
  PassTest = 'PassTest',
  PreventDanger = 'PreventDanger',
  Escape = 'Escape',
  Negotiate = 'Negotiate',
  Custom = 'Custom'
}

export enum MainEvent {
  TimeLimit = 'TimeLimit',
  ComplexMaze = 'ComplexMaze',
  StrongEnemy = 'StrongEnemy',
  Traitor = 'Traitor',
  Trap = 'Trap',
  CodeBreaking = 'CodeBreaking',
  NaturalDisaster = 'NaturalDisaster',
  LimitedResources = 'LimitedResources',
  FalseInformation = 'FalseInformation',
  EnemySurveillance = 'EnemySurveillance',
  PhysicalCrisis = 'PhysicalCrisis',
  ItemLoss = 'ItemLoss',
  Custom = 'Custom'
}

export enum Ending {
  HappyEnding = 'HappyEnding',
  BadEnding = 'BadEnding',
  TwistEnding = 'TwistEnding',
  OpenEnding = 'OpenEnding'
}

export interface StoryData {
  genre: Genre;
  temporalBackground: TemporalBackground;
  spatialBackground: SpatialBackground;
  atmosphere: string;
  storyGoal: string;
  mainEvent: string;
  ending: string;
  purpose: string;
}

// API 요청용 인터페이스 (실제 API 스펙에 맞춤)
export interface CreateProjectStoryAPI {
  genre: Genre;
  temporalBackground: string;
  spatialBackground: string;
  atmosphere: string;
  storyGoal: string;
  mainEvent: string;
  ending: string;
  purpose: string;
}

// React Hook Form에서 사용할 인터페이스 (내부 상태 관리용)
export interface CreateProjectStoryForm {
  genre: Genre | null;
  temporalBackground: TemporalBackground | null;
  spatialBackground: SpatialBackground | null;
  atmosphere: Atmosphere[]; // 최대 2개 선택 가능
  storyGoal: StoryGoal | null; // 스토리 목표
  storyGoalCustom: string; // 스토리 목표 직접 입력
  mainEvent: MainEvent | null; // 중심 사건
  mainEventCustom: string; // 중심 사건 직접 입력
  ending: Ending | null; // 결말
  purpose: string;
}

export const GENRE_OPTIONS = Object.values(Genre);
export const TEMPORAL_BACKGROUND_OPTIONS = Object.values(TemporalBackground);
export const SPATIAL_BACKGROUND_OPTIONS = Object.values(SpatialBackground);
export const ATMOSPHERE_OPTIONS = Object.values(Atmosphere);
export const STORY_GOAL_OPTIONS = Object.values(StoryGoal);
export const MAIN_EVENT_OPTIONS = Object.values(MainEvent);
export const ENDING_OPTIONS = Object.values(Ending);